import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {css, cx} from 'emotion'
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";
import './FieldsPropertyItemSettings.css';
import {PageService} from "PageBuilder/pagebuilder/services/PageService";
import {FieldControl} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";


export class FieldsPropertyItemSettings extends React.Component<FieldsPropertyItemSettingsProps, FieldsPropertyItemSettingsState> {
    static defaultProps: Partial<FieldsPropertyItemSettingsProps> = {};

    constructor(props: FieldsPropertyItemSettingsProps) {
        super(props);
        this.state = {
            SettingsIsOpen: false
        };
    }

    public render() {
        return (
            <div className={'handle fieldSettingsItem '+(this.state.SettingsIsOpen?'IsOpen':'')} style={{marginBottom:10}}>
                <div style={{width: '100%', position: 'relative', top: -10, display: 'flex', alignItems: 'center'}}>

                    <div className={'handle'}
                         style={{width: 'calc(100% - 90px)', display: 'inline-flex', alignItems: 'center',marginLeft:5}}>
                                                <span style={{cursor: "grab"}}>
                                                    <FontAwesomeIcon icon={'arrows-alt'}/>
                                                </span>
                        <label style={{
                            fontWeight: 'normal',
                            marginLeft: 3,
                            backgroundColor: 'white'
                        }}>{this.props.Field.Label}</label>
                    </div>
                    <div style={{width: 90, display: 'inline-block', textAlign: 'center'}}>
                        <div style={{display:'inline-block',backgroundColor:'white'}}>
                            <span onClick={e => this.props.OnDelete()} className={css`
                                                        cursor:pointer;
                                                        transition: 200ms ease-in-out color;
                                                        &:hover{
                                                          color:red
                                                        }
                                                        `}>
                                                    <FontAwesomeIcon icon={"trash"}/>
                                                </span>

                            <span onClick={e => this.ToggleSettings()} className={css`
                                                        cursor:pointer;
                                                        margin-left: 10px;
                                                        transition: 200ms ease-in-out color;
                                                        &:hover{
                                                          color:red
                                                        }
                                                        `}>
                                                    <FontAwesomeIcon icon={faCog}/>
                                                </span>
                        </div>
                    </div>
                </div>
                <SwitchContainer>
                    {this.state.SettingsIsOpen&&
                        <div style={{padding:10}}>
                            {this.GetSettings()}
                        </div>
                    }
                </SwitchContainer>

            </div>
        )
    }

    private ToggleSettings() {
        this.setState({
            SettingsIsOpen:!this.state.SettingsIsOpen
        });
    }

    private GetSettings() {
        let fieldControl=new FieldControl();

        fieldControl.Options=this.props.Field.FieldSettings;
        let properties=[new DropDownProperty(fieldControl,'Style').SetLabel("Style")
            .AddOption('Standard','standard')
            .AddOption('Similar to field','similar')];


        return properties.map(x=>x.renderer('1'))

    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldsPropertyItemSettingsProps {
    Field: { Id: string; Label: string, FieldSettings: FieldControlOptions };
    OnDelete: () => void;
}

interface FieldsPropertyItemSettingsState {
    SettingsIsOpen: boolean;
}

//#endregion "My Region"